var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Badge, Box, Checkbox, FormControl, Grid, TextField, Typography, useTheme } from '@mui/material';
import { Fragment } from 'react';
import { Controller } from 'react-hook-form';
import useTranslate from '../../../localization/helpers';
var ReAssignSerial = function (_a) {
    var viewMode = _a.viewMode, form = _a.form, clients = _a.clients, serialNumbers = _a.serialNumbers, totalSerials = _a.totalSerials, modelNumber = _a.modelNumber, isLoading = _a.isLoading, selectedSerials = _a.selectedSerials, setSelectedSerials = _a.setSelectedSerials, selectAll = _a.selectAll, setSelectAll = _a.setSelectAll, translate = _a.translate;
    var theme = useTheme();
    var tWithField = useTranslate().tWithField;
    var control = form.control, errors = form.formState.errors;
    var handleToggleAll = function () {
        if (selectAll) {
            setSelectedSerials([]);
        }
        else {
            setSelectedSerials(__spreadArray([], __read(serialNumbers), false));
        }
        setSelectAll(!selectAll);
    };
    var handleToggle = function (serialNumber) {
        var currentIndex = selectedSerials.indexOf(serialNumber);
        var newSelected = __spreadArray([], __read(selectedSerials), false);
        if (currentIndex === -1) {
            newSelected.push(serialNumber);
        }
        else {
            newSelected.splice(currentIndex, 1);
        }
        setSelectedSerials(newSelected);
        setSelectAll(newSelected.length === serialNumbers.length);
    };
    return (_jsxs(Box, { component: 'form', noValidate: true, autoComplete: 'off', children: [_jsx(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', p: '8px 16px', sx: { backgroundColor: theme.palette.background.neutral }, borderRadius: 1.5, children: _jsxs(Box, { display: 'flex', flex: '1 1 auto', alignItems: 'flex-start', gap: 1, children: [_jsx(Checkbox, { color: 'primary', checked: selectAll, onChange: handleToggleAll }), _jsxs(Box, { display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '4px', flex: '1 1 auto', children: [_jsx(Typography, { fontSize: '18px', fontWeight: 500, sx: { wordBreak: 'break-all', color: theme.palette.text.primary }, children: modelNumber }), _jsx(Badge, { badgeContent: "".concat(totalSerials, " ").concat(translate('assets.serialNumbers')), color: 'default', overlap: 'circular', sx: {
                                        '& .MuiBadge-badge': {
                                            backgroundColor: '#E4E6EB',
                                            color: '#161C24',
                                            width: 'max-content',
                                            position: 'relative',
                                            transform: 'none',
                                            top: 'auto',
                                            right: 'auto'
                                        }
                                    } })] })] }) }), _jsxs(Box, { my: 2.5, display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(Box, { children: _jsx(Typography, { variant: 'subtitle1', color: 'rgba(69, 79, 91, 1)', children: translate('assets.selectSerialNumber') }) }), _jsx(Box, { maxHeight: 400, overflow: 'auto', gap: 1, display: 'flex', flexDirection: 'column', sx: { p: 0 }, children: serialNumbers.map(function (serialNumber) { return (_jsxs(Box, { padding: '8px 16px', width: '100%', bgcolor: 'rgba(255, 255, 255, 1)', boxShadow: theme.customShadows.z8, display: 'flex', borderRadius: '12px', gap: 1, alignItems: 'center', my: 1, children: [_jsx(Checkbox, { checked: selectedSerials.includes(serialNumber), onChange: function () { return handleToggle(serialNumber); } }), _jsx(Box, { width: '100%', children: _jsx(Box, { children: _jsx(Typography, { variant: 'body1', sx: { wordBreak: 'break-all' }, children: serialNumber }) }) })] }, serialNumber)); }) })] }), viewMode === 'reassign' && (_jsxs(Fragment, { children: [_jsx(Box, { my: 2.5, color: 'rgba(69, 79, 91, 1)', children: _jsxs(Typography, { variant: 'subtitle1', children: [translate('assets.assignTo'), ":"] }) }), _jsx(Grid, { container: true, spacing: 3, children: _jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'clientId', control: control, rules: {
                                    required: tWithField('validations.fieldIsRequired', 'common.client')
                                }, render: function (_a) {
                                    var _b = _a.field, onChange = _b.onChange, value = _b.value;
                                    return (_jsx(FormControl, { size: 'medium', fullWidth: true, variant: 'outlined', children: _jsx(Autocomplete, { sx: {
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '8px'
                                                }
                                            }, disabled: isLoading, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, value: clients.find(function (client) { return value === client.id; }) || null, options: clients || [], getOptionLabel: function (option) { return option.name; }, renderInput: function (params) {
                                                var _a;
                                                return (_jsx(TextField, __assign({}, params, { disabled: isLoading, error: !!(errors === null || errors === void 0 ? void 0 : errors.clientId), variant: 'outlined', fullWidth: true, label: translate('common.client'), helperText: (_a = errors === null || errors === void 0 ? void 0 : errors.clientId) === null || _a === void 0 ? void 0 : _a.message })));
                                            }, onChange: function (_, value) {
                                                onChange(value === null || value === void 0 ? void 0 : value.id);
                                            }, renderOption: function (props, option) {
                                                return option !== null && (_createElement("li", __assign({}, props, { key: option.id }), option.name));
                                            }, noOptionsText: translate('common.noOptions') }) }));
                                } }) }) })] }))] }));
};
export default ReAssignSerial;
